import React, { useContext } from 'react'
import './M_TimeLine.css'
import { Timeline } from "primereact/timeline/timeline.cjs.js"
import { useMediaQuery, Tooltip } from '@mui/material'
import { LoadingContext } from '../M_Utils'
import Brightness1Icon from '@mui/icons-material/Brightness1'
import PropTypes from 'prop-types'

export function MTimeLine({
    valueTimeline, color, timeLineBreak, bottomPosition, forceVertical, subHeaderSize
}) {

    const matches = useMediaQuery(`(max-width:${timeLineBreak || "600px"})`)
    const ctx = useContext(LoadingContext)

    const isVertical = forceVertical || matches
    const newColor = color || ctx.primaryColor || 'var(--color-black)'
    const verticalStyle = { marginTop: '-20px', width: '350px', height: '70px', left: '-20px', top: '-20px' }
    const horizontalStyle = {
        width: '155px', position: 'relative', left: '-60px',
        display: 'flex', alignItems: 'end', justifyContent: 'center',
        marginBottom: bottomPosition ? '5px' : '10px',
        marginTop: bottomPosition ? '5px' : '0px'
    }

    const renderHeader = (item) => {
        const content = item.subHeader === '' ?
            <>{item.header}</>
            : (
                <div style={{ display: 'grid', fontSize: subHeaderSize || '15px' }}>
                    <b>{item.header}</b>
                    {item.subHeader}
                </div>
            )

        return item.toolTipLabel ? <Tooltip title={item.toolTipLabel}>{content}</Tooltip> : content
    }

    const containerTimeline = (item) => (
        <div style={isVertical ? verticalStyle : horizontalStyle}>
            <br />
            {renderHeader(item)}
        </div>
    )

    const timelineMarker = (item) => {
        return (
            <div style={{ color: newColor, display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2rem' }} >
                <div>{(item.marker) || <Brightness1Icon style={{ color: newColor }} />}</div>
            </div>
        )
    }

    return (
        <div className='principalDivM_TimeLine'>
            <div className='divM_TimeLine'>
                <Timeline
                    value={valueTimeline}
                    align={isVertical ? "left" : bottomPosition ? "bottom" : "top"}
                    layout={isVertical ? "vertical" : "horizontal"}
                    marker={timelineMarker}
                    content={containerTimeline}
                    className="custom-timeline"
                />
            </div>
        </div>
    )
}

MTimeLine.propTypes = {
    valueTimeline: PropTypes.any,
    color: PropTypes.string,
    timeLineBreak: PropTypes.bool,
    bottomPosition: PropTypes.bool,
    forceVertical: PropTypes.bool,
    subHeaderSize: PropTypes.string,
}